import { useTranslation } from 'react-i18next';
import { ThirdParty } from '@/components/biz/third-party';
import { StepBox } from '@/components/layout/step-box';
import { Flow } from '@/constants/flow';
import { useBizState } from '@/hooks/use-biz-state';

export const StepSocialLoginMore: React.FC = () => {
  const { t } = useTranslation();
  const { socialAuthRedirecting } = useBizState();
  return (
    <StepBox
      backFlow={Flow.LOGIN_STEP_INPUT_USERNAME}
      backButtonProps={{
        disabled: socialAuthRedirecting,
      }}
      title={t('more_options')}
    >
      <ThirdParty source="more" />
    </StepBox>
  );
};
